
<form [formGroup]="form" class="mt-3">
  <control-wrapper
    label="Visibility"
    [control]="form.controls['visibility']"
    *ngIf="showVisibilityButtons"
  >
    <div class="btn-group" role="group" aria-label="Visibility options">
      <input
        type="radio"
        class="btn-check"
        id="private"
        value="1"
        formControlName="visibility"
        (change)="onVisibilityChange($event)"
      />
      <label class="btn btn-outline-primary" for="private">Just me</label>

      <input
        type="radio"
        class="btn-check"
        id="SelectedContacts"
        value="2"
        formControlName="visibility"
        (change)="onVisibilityChange($event)"
      />
      <label class="btn btn-outline-primary" for="SelectedContacts"
        >Selected Contacts</label
      >

      <input
        type="radio"
        class="btn-check"
        id="unrestricted"
        value="0"
        formControlName="visibility"
        (change)="onVisibilityChange($event)"
      />
      <label class="btn btn-outline-primary" for="unrestricted"
        >Unrestricted</label
      >
    </div>
  </control-wrapper>


  <control-wrapper
    *ngIf="
      accessControl.visibility == Visibility.SelectedContacts && showTenancyOptions && tenancyKeyValues.length > 0
    "
    label="Tenancy"
    [control]="form.controls['tenancy']"
  >
    <tlp-generic-select
      [items]="tenancyKeyValues"
      [multiple]="true"
      (selectionChange)="onTenancySelected($event)"
      [bindLabel]="'value'"
      [initialSelectedItems]="preselectedTenancies"
    >
    </tlp-generic-select>
  </control-wrapper>

  <control-wrapper
    *ngIf="accessControl.visibility == Visibility.SelectedContacts && showContactOptions"
    label="Individuals"
    [control]="form.controls['contact']"
  >
    <tlp-contact-search
      (contactSelected)="onContactSelected($event)"
      (selectedItems)="onSelectedContacts($event)"
      [multiple]="true"
      [maxSelectedItems]="20"
      [preselectedContactIds]="memberIds"
      [tenantsOnly]="true"
    >
    </tlp-contact-search>
  </control-wrapper>

  
  <div *ngIf="accessControl.visibility == Visibility.SelectedContacts && showTenancyOptions && tenancyKeyValues.length > 0">
    <control-wrapper label="">
      <div class="border border-primary rounded-3 text-primary fw-bold p-2">

      <p class="mt-2">
        You can select a combination of tenancies and individuals to control
        visibility to this document.
      </p>

      <p >
        Selecting a tenancy will automatically include all tenants within that
        tenancy.
      </p>

      </div>
    </control-wrapper>
  </div>
</form>
